import { j as e } from "../../../_virtual/jsx-runtime.js";
import { useState as m, useMemo as y } from "react";
import n from "styled-components";
import p from "../Input.js";
import { Form as t, message as o } from "antd";
import P from "../Button.js";
import j from "./comps/Success.js";
import { useNavigate as v, useSearchParams as S } from "react-router-dom";
import { useIsMobile as b } from "../../hook/useIsMobile.js";
import { setNewUserPassword as z } from "../../api/auth/index.js";
function $(u) {
  const [l] = t.useForm(), [f, w] = m(!1), [h, a] = m(!1), g = v(), i = b(), [c] = S(), x = y(() => c.get("token"), [c]);
  return f ? /* @__PURE__ */ e.jsx(j, { title: "Setup Successful!", description: "Jumping to the login page for you" }) : /* @__PURE__ */ e.jsxs(C, { children: [
    /* @__PURE__ */ e.jsx("div", { children: u.logo }),
    /* @__PURE__ */ e.jsx(F, { children: "Set Password" }),
    /* @__PURE__ */ e.jsx(I, { children: "Setting a password for your account" }),
    /* @__PURE__ */ e.jsxs(
      t,
      {
        style: { width: "100%" },
        form: l,
        onFinish: async () => {
          const s = await l.validateFields();
          if (s.password !== s.confirmPassword) {
            o.error("Passwords do not match");
            return;
          }
          a(!0);
          try {
            const r = await z(
              {
                password: s.password
              },
              x
            );
            if (r.code !== 0) {
              o.error(r.message), a(!1);
              return;
            }
            o.success("Password set successfully"), w(!0), g("/login", { replace: !0 });
          } catch {
            o.error("Password set failed"), a(!1);
          }
        },
        children: [
          /* @__PURE__ */ e.jsx(
            t.Item,
            {
              name: "password",
              rules: [
                { required: !0, message: "Please input your password!" },
                {
                  pattern: /^[a-zA-Z0-9]{8,25}$/,
                  message: "Please enter the correct password!"
                }
              ],
              children: /* @__PURE__ */ e.jsx(p, { placeholder: "Use 8-25 English letters and numbers", label: "Password", variant: "password", style: { width: i ? "100%" : 392 }, autoComplete: "new-password" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            t.Item,
            {
              name: "confirmPassword",
              rules: [
                { required: !0, message: "Please confirm your password!" },
                {
                  pattern: /^[a-zA-Z0-9]{8,25}$/,
                  message: "Please enter the correct password!"
                },
                ({ getFieldValue: s }) => ({
                  validator(r, d) {
                    return !d || s("password") === d ? Promise.resolve() : Promise.reject(new Error("Passwords do not match!"));
                  }
                })
              ],
              children: /* @__PURE__ */ e.jsx(p, { placeholder: "Repeat your password again", label: "Confirm Password", variant: "password", style: { width: i ? "100%" : 392 }, autoComplete: "new-password" })
            }
          ),
          /* @__PURE__ */ e.jsx(
            P,
            {
              htmlType: "submit",
              type: "primary",
              loading: h,
              style: {
                width: i ? "100%" : 392,
                height: 52,
                marginTop: 35,
                fontSize: 18,
                fontWeight: 500
              },
              children: "Confirm"
            }
          )
        ]
      }
    )
  ] });
}
const C = n.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`, F = n.div`
  color: var(--color-text);
  font-family: 'Poppins';
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 8px;
`, I = n.div`
  color: var(--color-text-07);
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 32px;
  text-align: center;
`;
export {
  $ as default
};
